// extracted by mini-css-extract-plugin
export default {"releaseBtn":"ReleaseStyles_releaseBtn__8Sq67"};